import { render, staticRenderFns } from "./Agreement2.vue?vue&type=template&id=0bbe72c4&scoped=true"
import script from "./Agreement2.vue?vue&type=script&lang=js"
export * from "./Agreement2.vue?vue&type=script&lang=js"
import style0 from "./Agreement2.vue?vue&type=style&index=0&id=0bbe72c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbe72c4",
  null
  
)

export default component.exports